module.exports = __webpack_public_path__ + "static/media/real_estate.969b4869.png";